export const handleErrorMock = {
  errorId: 'ErrorGetting3DModel',
  errorHeader: 'Failed to load viewer',
  errorDescription:
    'Error occurred while trying to load viewer. please try again later.',
};
